export type IWarnFileOverwrite = (
  input: HTMLInputElement | JQuery<HTMLInputElement>,
  fileNameSpan: IjQueryElmOrHtmlElm,
  fileName: string
) => void;

export function _warnFileOverwrite(
  input: HTMLInputElement | JQuery<HTMLInputElement>,
  fileNameSpan: IjQueryElmOrHtmlElm,
  fileName: string
): void {
  const options = window.DexeroCoreApp.getUserOptions();
  const { langObj = {} } = options;
  const { imageOverwriteText, imageOverwriteMsgText } = langObj;

  const promise = window.DexeroCoreApp.confirmUserAction(
    'warning',
    imageOverwriteText,
    `${imageOverwriteMsgText} ${fileName}`
  );
  promise.done(() => {
    $(fileNameSpan).addClass('overwrite-file');
    $(input).trigger('click');
  });
}
